import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  containerStyle: {
    alignItems: "center",
    margin: "3vh",
    marginTop: 0,
    width: "70vw",
  },
  questionTextStyle: {
    fontSize: "$question_text_size",
    fontFamily: "$question_text_style",
    textAlign: "center",
    color: "$question_text",
  },
});
